/**
 * Catalogo dei moduli a interruttore.
 *
 * Un modulo e una funzione che non fa parte del perimetro base: si accende a una singola
 * azienda dopo l'accordo economico, non si costruisce dentro il prezzo del prodotto.
 * Qui vive l'unico elenco: chiave, nome parlante e cosa promette. Non scrivere elenchi
 * paralleli fra client e server, e la lezione delle unita di misura in `material-units.ts`.
 *
 * Regola d'oro: **spento e il valore di partenza**. Nessuna azienda nasce con un modulo
 * acceso, nemmeno la dimostrativa: l'assenza di una riga in `company_modules` vale spento.
 */
export const MODULE_KEYS = ["weekly_schedule", "pool_log", "email_automation", "communications"] as const;

export type ModuleKey = (typeof MODULE_KEYS)[number];

export type ModuleDescriptor = {
  key: ModuleKey;
  label: string;
  description: string;
};

export const MODULE_CATALOG: Record<ModuleKey, ModuleDescriptor> = {
  weekly_schedule: {
    key: "weekly_schedule",
    label: "Programmazione settimanale",
    description: "Vista a settimana per collaboratore e giri che si ripetono da ogni settimana fino a ogni otto.",
  },
  pool_log: {
    key: "pool_log",
    label: "Registro piscine",
    description: "Cloro, pH e azioni di vasca per struttura, con reintegro d'acqua in litri, storico consultabile e foglio stampabile.",
  },
  email_automation: {
    key: "email_automation",
    label: "Email automatiche",
    description: "Invio automatico degli ordini e delle richieste materiali al fornitore.",
  },
  communications: {
    key: "communications",
    label: "Comunicazioni",
    description: "Chat interna fra chi dirige e i collaboratori, chiusa dentro l'azienda e non leggibile da fuori.",
  },
};

export const MODULE_LIST: ModuleDescriptor[] = MODULE_KEYS.map((key) => MODULE_CATALOG[key]);

export function isModuleKey(value: string): value is ModuleKey {
  return (MODULE_KEYS as readonly string[]).includes(value);
}

export function moduleLabel(key: ModuleKey) {
  return MODULE_CATALOG[key].label;
}
